import { UiButton, UiDrawer, UiProfileModel } from "../../../../components";
import UiWarningRating from "../../../../components/uiWarning";
import { lang_en_US as translation } from "../../../../config";
import { Tooltip } from "antd";
import "./style.scss";
import { useReactToPrint } from "react-to-print";
import React, { useRef } from "react";
import dayjs from "dayjs";
import { formatPhoneNumber, markdownToHtml } from "../../../../utils/appUtils";
import ApprovedlawyerReport from "../reports/approvedLawyerReport";
import AgreementReport from "../reports/agreementReport";

const LawyerProfileReportPrint = React.forwardRef((props, ref) => (
    <div ref={ref}>
        <ApprovedlawyerReport lawyerProfileData={props?.lawyerProfileData} activeTab={props?.activeTab} lawyerProfilePic={props?.lawyerProfilePic} />
    </div>
));



const ProfileView = ({
    lawyerBooleans,
    lawyerFilter,
    handleProfileCancel,
    lawyerProfileData,
    agreementMd,
}) => {
    const keywords = translation;
    const profileRef = useRef();
    const agreementRef = useRef();

    const salutation = lawyerProfileData?.salutation || "";
    const firstName = lawyerProfileData?.firstName || "";
    const middleName = lawyerProfileData?.middleName || "";
    const lastName = lawyerProfileData?.lastName || "";
    const fullName = [salutation, firstName, middleName, lastName].filter(Boolean).join(" ");

    const processedMd = agreementMd.replace(/\*\{\{NAME\}\}\*/g, `**${fullName}**`).replace(/\{\{NAME\}\}/g, `**${fullName}**`);
    const agreementHtml = markdownToHtml(processedMd);

    const handleAgreementPrint = useReactToPrint({
        content: () => agreementRef.current,
        documentTitle: "Advocate User Agreement",
        pageStyle: `
            body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            .approval-Report::before {
                content: "";
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                border: 2px solid #005D60;
                z-index: 9999;
                pointer-events: none;
            }
        `
    });

    const specializationList = Array.isArray(lawyerProfileData?.specialization)
        ? lawyerProfileData?.specialization?.filter((specializationItem) => Boolean(specializationItem))
        : [];
    const specializationCount = specializationList?.length || 0;
    const specializationText = specializationList?.join(", ");
    const specializationDisplayText = specializationCount > 2
        ? `${specializationList?.slice(0, 2)?.join(", ")}...`
        : specializationText || "Nil";
    const firstBlockInfo = lawyerProfileData?.blockInfo?.[0];
    const hasBlockInfoValues =
        (firstBlockInfo?.blockDays !== null && firstBlockInfo?.blockDays !== undefined)
        || Boolean(firstBlockInfo?.blockDate)
        || Boolean(firstBlockInfo?.reason);
    const handleProfileReportPrint = useReactToPrint({
        content: () => profileRef.current,
        documentTitle: "Lawyer Profile Report",
        pageStyle:
            `body {
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                    }
            .approval-Report::before{
                    content: "";
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    border: 2px solid #005D60;
                    z-index: 9999;
                    pointer-events: none;
            }
                `
    });
    return <>
        <UiDrawer
            open={lawyerBooleans?.openProfileView}
            onClose={handleProfileCancel}
            title={keywords?.lawyerManagement?.viewProfileTitle}
            width={600}
            footer={<>
                <div className="flexible-end">
                    <UiButton onClick={handleProfileCancel}>Close</UiButton>
                    <UiButton type="primary" onClick={handleAgreementPrint} disabled={!agreementHtml}>Download Agreement</UiButton>
                    <UiButton type="primary" onClick={handleProfileReportPrint}>Download Report</UiButton>
                </div>
            </>}
        >
            <div className="lawyer-information">
                <div className="flexible" style={{ borderBottom: "1px solid #000" }}>
                    <div className="flexible">
                        <UiProfileModel imageUrl={lawyerFilter?.lawyerProfilePic} />
                        <div>
                            {
                                lawyerFilter?.activeTab === "REJECTED" && <h3 className="lawerInfo-detail" style={{paddingTop:"15px"}}>{lawyerProfileData?.salutation} {lawyerProfileData?.firstName} {lawyerProfileData?.middleName} {lawyerProfileData?.lastName}</h3>
                            }
                            {lawyerFilter?.activeTab === "APPROVED" && <div style={{ padding: "5px 10px" }}>
                                <h3 className="lawerInfo-detail" style={{}}>{lawyerProfileData?.salutation} {lawyerProfileData?.firstName} {lawyerProfileData?.middleName} {lawyerProfileData?.lastName}</h3>
                                <UiWarningRating count={lawyerProfileData?.warningCountAfterActive} />
                            </div>}
                        </div>
                    </div>
                    {
                        lawyerFilter?.activeTab === "APPROVED" && <div className="flexible">
                        <div>
                            <small className="information-header">Advocate ID</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.lawyerNo || "Nil"}</h3>
                        </div>
                    </div>
                    }
                </div>
                <div className="flexible">
                    <div>
                        <small className="information-header">Mobile Number</small>
                        <h3 className="lawerInfo-detail"> {lawyerProfileData?.mobileNumber ? formatPhoneNumber(lawyerProfileData?.mobileNumber) : "Nil"}</h3>
                    </div>
                    <div>
                        <small className="information-header">E-mail Address</small>
                        <h3 className="lawerInfo-detail">{lawyerProfileData?.email || "Nil"}</h3>
                    </div>
                </div>
            </div>
            <div className="lawyer-details">
                <div>
                    <div style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px" }}>
                        <h3 className="lawyerInfo-heading" >Consultion Details</h3>
                    </div>
                    <div className="flexible-start">
                        <div>
                            <small className="information-header">Total Cons.</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.totalConsultation ? lawyerProfileData?.totalConsultation : 0}</h3>
                        </div>
                        <div>
                            <small className="information-header">Upcoming Cons.</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.upcomingConsultation ? lawyerProfileData?.upcomingConsultation : 0}</h3>
                        </div>
                        <div>
                            <small className="information-header">Cancel Cons.</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.totalCancelConsultation ? lawyerProfileData?.totalCancelConsultation : 0}</h3>
                        </div>
                    </div>
                </div>
                <div style={{ padding: "10px 0px" }}>
                    <div style={{ borderBottom: "1px solid #00000054", padding: "10px 0px" }}>
                        <h3 className="lawyerInfo-heading">Professional Details</h3>
                    </div>
                    <div className="flexible">
                        <div>
                            <small className="information-header">Bar Council No</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.barCouncilId || "Nil"}</h3>
                        </div>
                        <div>
                            <small className="information-header">Enrolment No.</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.enrollmentNo || "Nil"}</h3>
                        </div>
                        <div>
                            <small className="information-header">Experience</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.experience ? `${lawyerProfileData?.experience} Years` : "Nil"}</h3>
                        </div>
                        <div>
                            <small className="information-header">Qualification</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.qualification || "Nil"}</h3>
                        </div>
                    </div>
                    <div style={{ padding: "10px 0px" }}>
                        <small className="information-header">Specialization</small>
                        <h3 className="lawerInfo-detail">
                            {specializationCount > 2 ? (
                                <Tooltip title={specializationText}>
                                    <span>{specializationDisplayText}</span>
                                </Tooltip>
                            ) : specializationDisplayText}
                        </h3>
                    </div>
                </div>
                <div>
                    <div style={{ borderBottom: "1px solid #00000054", padding: "10px 0px" }}>
                        <h3 className="lawyerInfo-heading">Personal Details</h3>
                    </div>
                    <div className="flexible">
                        <div style={{ width: "50%" }}>
                            <small className="information-header">Address 1</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.address1 || "Nil"}</h3>
                        </div>
                        <div style={{ width: "50%" }}>
                            <small className="information-header">Address 2</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.address2 || "Nil"}</h3>
                        </div>
                    </div>
                    <div className="flexible">
                        <div>
                            <small className="information-header">State</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.state || "Nil"}</h3>
                        </div>
                        <div>
                            <small className="information-header">District</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.district || "Nil"}</h3>
                        </div>
                        <div>
                            <small className="information-header">City</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.city || "Nil"}</h3>
                        </div>
                        <div>
                            <small className="information-header">Pincode</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.pincode || "Nil"}</h3>
                        </div>
                    </div>
                </div>
                <div>
                    <div style={{ borderBottom: "1px solid #00000054", padding: "10px 0px" }}>
                        <h3 className="lawyerInfo-heading">Bio/About You</h3>
                    </div>
                    <div>
                        <p>{lawyerProfileData?.aboutAs || "Nil"}</p>
                    </div>
                </div>
                {
                    lawyerFilter?.activeTab === "HOLD" && hasBlockInfoValues && (
                        <div>
                            <div style={{ borderBottom: "1px solid #00000054", padding: "10px 0px" }}>
                                <h3 className="lawyerInfo-heading">Block Details</h3>
                            </div>
                            <div className="flexible">
                                <div>
                                    <small className="information-header">Block Days</small>
                                    <h3 className="lawerInfo-detail">{firstBlockInfo?.blockDays ?? "Nil"}</h3>
                                </div>
                                <div>
                                    <small className="information-header">Block Date</small>
                                    <h3 className="lawerInfo-detail">{firstBlockInfo?.blockDate ? dayjs(firstBlockInfo?.blockDate)?.format("YYYY-MM-DD HH:mm:ss") : "Nil"}</h3>
                                </div>
                                <div>
                                    <small className="information-header">Reason</small>
                                    <h3 className="lawerInfo-detail">{firstBlockInfo?.reason || "Nil"}</h3>
                                </div>
                            </div>
                        </div>
                    )
                }
                {
                    lawyerFilter?.activeTab === "REJECTED" && <div>
                        <div style={{ borderBottom: "1px solid #00000054", padding: "10px 0px" }}>
                            <h3 className="lawyerInfo-heading">Reason For Rejected</h3>
                        </div>
                        <div>
                            <p>{lawyerProfileData?.approvalInfo?.rejectedReason || "Nil"}</p>
                        </div>
                    </div>
                }
            </div>
        </UiDrawer>
        <div style={{ display: "none" }}>
            <LawyerProfileReportPrint ref={profileRef} lawyerProfileData={lawyerProfileData} activeTab={lawyerFilter?.activeTab} lawyerProfilePic={lawyerFilter?.lawyerProfilePic} />
            <AgreementReport ref={agreementRef} htmlContent={agreementHtml} />
        </div>
    </>
};
export default ProfileView